import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=49b28dd4&scoped=true"
import script from "./InputRadio.vue?vue&type=script&lang=ts"
export * from "./InputRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b28dd4",
  null
  
)

export default component.exports